// src/plugins/vuetify.js

import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        //primary: '#34827e',
        // #8C8074, #8697A6, #51608C,#F27405, #0A87C7
      }
    }
  }
};

export default new Vuetify(opts);
